// extracted by mini-css-extract-plugin
export default {"root":"wSyVa0ZyxTmVwfY3pbCN","dag":"Ubs_DqMGHYWApvIF6CQf"};